import styled from "styled-components/macro";

export type DatepickerSize = "small" | "medium";

export const DatepickerStyledRoot = styled.div<{
  horizontalLabel?: boolean;
  size?: DatepickerSize;
  dateStyle?: "short" | "long";
  fullWidth?: boolean;
}>`
  position: relative;
  display: flex;
  flex-direction: ${(props) => (props.horizontalLabel ? "row" : "column")};
  gap: ${(props) => (props.horizontalLabel ? "0.5em" : "0.25em")};
  position: relative;
  align-items: ${(props) => (props.horizontalLabel ? "center" : null)};

  label {
    font-family: var(--inter-font);
    font-size: var(--font-size-small);
  }

  input[type="date"]::-webkit-inner-spin-button,
  input[type="date"]::-webkit-calendar-picker-indicator,
  input[type="month"]::-webkit-inner-spin-button,
  input[type="month"]::-webkit-calendar-picker-indicator {
    display: none;
    -webkit-appearance: none;
  }

  input[type="date"],
  input[type="month"] {
    ${({ dateStyle }) => {
      if (dateStyle === "short") {
        return `
        position: absolute;
        opacity: 0;
        cursor: pointer;
        height: 0;
        width: 0;
        `;
      }
    }}

    padding: ${({ size }) => (size === "small" ? "0.5rem" : "0.7rem 0.9rem")};
    border: 1px solid var(--border-gray);
    border-radius: var(--rounded-corner);
    font-family: var(--inter-font);
    transition: var(--transition);
    max-width: ${({ fullWidth }) => (fullWidth ? "100%" : "15rem")};

    &.error {
      border-color: var(--error-color);
    }
    &:hover {
      border-color: var(--dark-gray);
      box-shadow: var(--drop-shadow-light);
    }
    &:focus {
      outline: none;
      border-color: var(--green);
      box-shadow: var(--drop-shadow-light);
    }
  }

  span.error {
    color: var(--error-color);
    font-family: var(--inter-font);
    font-size: var(--font-size-small);
  }

  .date-display {
    cursor: pointer;
    display: flex;
    align-items: center;
    background: white;
    padding: 0.5rem 0.6rem 0.5rem 0.75rem;
    border-radius: var(--rounded-corner);
    border: 1px solid var(--border-gray);
    user-select: none;

    &.focus {
      outline: none;
      border-color: var(--green);
      box-shadow: var(--drop-shadow-light);
    }

    & > * {
      pointer-events: none;
    }

    .down-icon {
      margin-left: 0.5rem;
    }
  }
`;
